import { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper.tsx';

export const ErrorIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                // eslint-disable-next-line max-len
                d="M7.65 12.35h8.7v-.7h-8.7v.7Zm4.354 8.35a8.482 8.482 0 0 1-3.393-.685 8.79 8.79 0 0 1-2.764-1.858 8.779 8.779 0 0 1-1.861-2.761 8.458 8.458 0 0 1-.686-3.392c0-1.202.228-2.334.685-3.393a8.79 8.79 0 0 1 1.859-2.764 8.78 8.78 0 0 1 2.76-1.861 8.458 8.458 0 0 1 3.392-.686c1.203 0 2.334.228 3.393.685a8.79 8.79 0 0 1 2.764 1.859 8.779 8.779 0 0 1 1.861 2.76 8.457 8.457 0 0 1 .686 3.392 8.482 8.482 0 0 1-.685 3.393 8.789 8.789 0 0 1-1.858 2.764 8.778 8.778 0 0 1-2.761 1.861 8.457 8.457 0 0 1-3.392.686Z"
            />
        </svg>
    </IconWrapper>
));
